import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyTheme, loadTheme } from './lib/session';
// Fonts are bundled, not loaded from Google: no third-party requests from customers' browsers.
import '@fontsource/archivo/latin-400.css';
import '@fontsource/archivo/latin-500.css';
import '@fontsource/archivo/latin-600.css';
import '@fontsource/archivo/latin-700.css';
import '@fontsource/archivo/latin-800.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-500.css';
import './styles.css';
// --- The installable app (PWA): service worker, install and update prompts, notifications ----
import { UpdatePrompt } from './components/Notifications';
import { startPwa } from './pwa/pwa';

applyTheme(loadTheme());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// The installable app: registers /sw.js in production builds (never in development), and shows
// "A new version of Stitch is ready" from its own root, outside the app's routes.
startPwa();
const pwaRoot = document.createElement('div');
pwaRoot.id = 'pwa-root';
document.body.appendChild(pwaRoot);
createRoot(pwaRoot).render(<UpdatePrompt />);
